import React from 'react';
import ErrorService from './../../../../service/error';
import ValidateService from './../../../../service/validate';
import { FORM_FIELD } from './../../core/abstract';
import mapStateToProps from './../../../../store/map/auth-token';
import mapDispatchToProps from './../../../../store/map/on-logout';
import { connect } from 'react-redux';
import SearchPrompt from './../../core/search';
import { Header, SearchMetricsViewPrompt } from './view';
import theme from './../../../theme';

class _SearchMetricsPrompt extends SearchPrompt
{
    constructor(parms)
    {
        super(parms, _SearchMetricsPrompt.getValidators());

        this.getFieldsModel = this.getFieldsModel.bind(this);
        this.onSearchResponse = this.onSearchResponse.bind(this);
        this.onSearchError = this.onSearchError.bind(this);
        this.onSendToServer = this.onSendToServer.bind(this);
        this.getServerRequest = this.getServerRequest.bind(this);
        this.getSearchResultUi = this.getSearchResultUi.bind(this);
        this.onAuthError = this.onAuthError.bind(this);
        this.onFatalError = this.onFatalError.bind(this);
        this.onNetworkOffline = this.onNetworkOffline.bind(this);
        this.getSearchResultsUi = this.getSearchResultsUi.bind(this);
        this.getNoResultsUi = this.getNoResultsUi.bind(this);
        this.setSearchText = this.setSearchText.bind(this);
    }

    static getValidators()
    {
        return {
            searchText: {
                isValid: ValidateService.anyValue
            },
            noEarlierDateCode: {
                isValid: ValidateService.anyValue
            }
        };
    }

    onAuthError()
    {
        this.props.onLogout();
    }

    onFatalError()
    {
        this.props.onUpdateError(true, '');
    }

    onNetworkOffline()
    {
        this.props.onUpdateDeviceOnline(false);
    }

    getFieldsModel()
    {
        return {
            searchText: {
                name: 'Request',
                error: 'Specify a request',
                value: '',
                visible: true,
                valid: true,
                touched: false,
                type: FORM_FIELD.TEXT
            },
            noEarlierDateCode: {
                name: 'Time',
                error: 'Specify a time period',
                value: '',
                valueList: ErrorService.getPossibleTimePeriods(),
                visible: true,
                valid: true,
                touched: false,
                type: FORM_FIELD.DROP
            }
        };
    }

    onSearchResponse(response)
    {
        super.onSearchResponse(response, 'metrics');
    }

    onSendToServer(request = undefined)
    {
        ErrorService.adminSearchMetrics({
            request: request ? request : this.getServerRequest(),
            onResponse: this.onSearchResponse,
            onError: this.onSearchError,
            authToken: this.props.authToken,
            onAuthError: this.onAuthError,
            onFatalError: this.onFatalError,
            onNetworkOffline: this.onNetworkOffline
        });
    }

    getServerRequest()
    {
        return {
            page: 0,
            searchText: this.state.searchText.value,
            noEarlierDateCode: this.state.noEarlierDateCode.value
        };
    }

    onLoadSpecifiedPage(page)
    {
        this.setContactingServer(true);
        let request = this.getServerRequest();
        request.page = page;
        this.onSendToServer(request);
    }

    getNoResultsUi()
    {
        return (
            <div style={{
                ...theme.getGeneralTextStyle(theme)
            }}>
                <p>
                    No Metrics Found.
                </p>
            </div>
        );
    }

    setSearchText(text)
    {
        const nextState = this.state;
        nextState.searchText.value = text;
        this.setState(nextState);
        this.onSendToServer();
    }

    getSearchResultUi(aResult, index)
    {
        return <SearchMetricsViewPrompt 
            metric={aResult} 
            key={index} 
            setSearchText={this.setSearchText}
        />
    }

    getSearchResultsUi()
    {
        return this.state.results.length < 1 ? this.getNoResultsUi() : 
            <div>
                <table>
                    <Header />
                    <tbody>
                        {  this.state.results.map((aResult, index) => this.getSearchResultUi(aResult, index)) }
                    </tbody>
                </table>
            </div>
    }
}

const SearchMetricsPrompt = connect(mapStateToProps, mapDispatchToProps)(_SearchMetricsPrompt);
export default SearchMetricsPrompt;
